export enum AdminRoleTypes {
	superAdmin = 'super_admin',
}
